import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIPS_BY_TRUCK_ID } from 'api/query-keys.ts';
import type { TripRes } from 'api/swagger';

export const useGetTripsByTruckId = (truckId?: number) => {
  return useQuery<TripRes[]>({
    queryKey: [TRIPS_BY_TRUCK_ID, truckId],
    queryFn: async () => {
      const { data } = await http.get<TripRes[]>(`/v1/trips/active-by-truck/${truckId}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(truckId),
  });
};
